import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PostConstraintFormFields {

    public name: FormField
    public identifier: FormField
    public description: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          true,
        )
        this.identifier = new FormField(
          'identifier',
          'Identifier',
          null,
          FormFieldType.text,
          true,
        )
        this.description = new FormField(
          'description',
          'Description',
          null,
          FormFieldType.text,
          true,
          true,
          ""
        )

    }
}

const fields = new PostConstraintFormFields()

export const postConstraintFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  identifier: fields.identifier,
  description: fields.description,
};